//WMS - 入库管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

// //配置下拉框值集
// export const All_Sel_Option = 'all';
// //库存状态
// export const Mod_StockStatus_Types = {
//     ZERO: 0,  //待入库
//     ONE:  1   //已入库 
// }

export const Mod_StockStatus_Options = [
    // {id: All_Sel_Option, label: '全部'},    // 总部
    {id:1, label: '盘点中'},         
    {id: 99, label: '盘点完成'},     
];
export class WmsWarehousingApi {

    constructor() {
    }
    protected static groupUrl = '/wms/bill/check';
    // https://api.pre.mzdata.top/data-dist/api/dist/wms/bill/out/list
    // POST:https://testyz.yoozworld.cn/data-dist/api/dist/stock/query
    //盘点列表
    public static async getBillList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

    //新建盘点
    public static async saveBill(data) {
        let uri = this.groupUrl + '/newBill';
        return await ServerDistApi.send(uri, data);
    }
    // 获取盘点单号
     public static async handleGetInventorBill(data) {
     let uri = this.groupUrl + '/newBillNo';
     return await ServerDistApi.get(uri, data);
    }

    // //获取盘点单详情库单
    // public static async oneBill(data) {
    //     let uri = this.groupUrl + '/get';
    //     return await ServerDistApi.get(uri, data);
    // }

    
    //获取盘点单详情库单
    public static async oneBill(data) {
      let uri = this.groupUrl + '/info';
      return await ServerDistApi.get(uri, data);
  }
    //删除盘点
    public static async deleteBill(data){
        let uri =this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }

    // //仓位添加
    // public static async saveLoc(data) {
    //     let uri = this.groupUrl + '/loc/save';
    //     return await ServerDistApi.send(uri, data);
    // }
    
    // //获取仓位
    // public static async getLocList(data) {
    //     let uri = this.groupUrl + '/loc/list';
    //     return await ServerDistApi.send(uri, data);
    // }
    
    // //获取一个仓位信息
    // public static async oneLocList(data) {
    //     let uri = this.groupUrl + '/loc/get';
    //     return await ServerDistApi.get(uri, data);
    // }

   //盘点生效 
    public static async saveUpdate(data) {
            let uri = this.groupUrl + '/saveUpdate';
            return await ServerDistApi.send(uri, data);
 }
    //盘点保存
    public static async saveTemp(data) {
        let uri = this.groupUrl + '/saveTemp';
        return await ServerDistApi.send(uri, data);
}
    //获取库存
    public static async queryStock(data) {
        let uri = '/stock/query';
        return await ServerDistApi.send(uri, data);
  } 
}


